import { render, staticRenderFns } from "./sendManange.vue?vue&type=template&id=7da56a82&scoped=true&"
import script from "./sendManange.vue?vue&type=script&lang=js&"
export * from "./sendManange.vue?vue&type=script&lang=js&"
import style0 from "./sendManange.vue?vue&type=style&index=0&id=7da56a82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da56a82",
  null
  
)

export default component.exports